import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '../constants/query_keys';
import { apiV1 } from '../lib/api';
import { FIVE_MINUTES_IN_MS } from '../lib/time';

export const useWaterbodyRecommendations = (params: {
  waterbodySlug: string;
  speciesName?: string | null;
  techniqueName?: string | null;
  seasonGroupName?: string | null;
}) => {
  const { waterbodySlug, speciesName, seasonGroupName, techniqueName } = params;

  const requestParams = {
    species: speciesName,
    styles: techniqueName,
    season_group: seasonGroupName,
  };

  const waterbodyRecommendationsQuery = useQuery({
    queryKey: QueryKeys.WATERBODIES.RECOMMENDATIONS(waterbodySlug, requestParams),
    queryFn: async () => {
      const res = await apiV1.waterbodyRecommendationsFetch(waterbodySlug, requestParams);
      return res.data.data;
    },
    enabled:
      waterbodySlug != null &&
      // I'm not positive, but I can't imagine a scenario where we'd want recommendations with no params
      (speciesName != null || seasonGroupName != null || techniqueName != null),
    staleTime: FIVE_MINUTES_IN_MS,
  });
  const { data = [], isLoading } = waterbodyRecommendationsQuery;

  return {
    recommendations: data,
    isLoading,
  };
};
